<template>
    <div class="invoice-cont">
        <Modal v-model="invoiceModal" width="580px" :closable="false" :mask-closable="false">
            <div slot="header" class="invoice-title">
                <span>发票信息</span>
            </div>
            <div v-if="invoiceFlag === 1">
                <Checkbox v-model="invoiceOrNot">是否开发票？</Checkbox>
                <span class="invoice-msg" v-show="invoiceMsg">* 请先确定是否开发票</span>
            </div>
            <div v-if="invoiceFlag === 2">
                <!-- <p class="invoice-msg">说明：发票30个工作日之内下发</p> -->
                <Form ref="formValidate" :model="formInvoice" :label-width="100" :rules="formInvoiceValidate">
                    <FormItem label="发票类型">
                        <RadioGroup v-model="formInvoice.invoiceType">
                            <Radio label="1">个人</Radio>
                            <Radio label="2">公司</Radio>
                        </RadioGroup>
                    </FormItem>
                    <div v-if="formInvoice.invoiceType === '1'">
                        <Row>
                            <Col span="22">
                            <FormItem label="金额">
                                <span>￥{{ total }}</span>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="22">
                            <FormItem label="订单号">
                                <span>{{ orderNum }}</span>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="22">
                            <FormItem label="发票抬头" prop="titlePerson">
                                <Input v-model="formInvoice.titlePerson" style="width: 90%" placeholder="请输入发票抬头"></Input>
                            </FormItem>
                            </Col>
                        </Row>
                    </div>
                    <div v-if="formInvoice.invoiceType === '2'">
                        <Row>
                            <Col span="22">
                            <FormItem label="金额">
                                <span>￥{{ total }}</span>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="22">
                            <FormItem label="订单号">
                                <span>{{ orderNum }}</span>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="22">
                            <FormItem label="发票抬头" prop="titleBusiness">
                                <Input v-model="formInvoice.titleBusiness" style="width: 90%" placeholder="请输入发票抬头"></Input>
                            </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span="22">
                            <FormItem label="纳税人识别号" prop="compTaxBusiness">
                                <Input v-model="formInvoice.compTaxBusiness" style="width: 90%" placeholder="请输入纳税人识别号"></Input>
                            </FormItem>
                            </Col>
                        </Row>
                    </div>
                </Form>
            </div>
            <div slot="footer">
                <Button type="ghost" @click="handleCancel">取消</Button>
                <Button type="primary" @click="handleConfirm('formValidate')">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { postInvoiceSave } from "../api/invoice";

export default {
    name: "Invoice",
    props: {
        total: {
            type: String,
            default: "",
        },
        orderNum: {
            type: String,
            default: "",
        },
    },
    data() {
        //检验税号
        const validateCompTax = (rule, value, callback) => {
            value = value.replace(/\s/g, "");
            let patternCompTax = /^[A-Z0-9]+$/;
            if (!value) {
                return callback(new Error("纳税人识别号不可为空"));
            } else if (
                value.length !== 15 &&
                value.length !== 18 &&
                value.length !== 20
            ) {
                return callback(
                    new Error("纳税人识别号字符长度只能为15、18或20位")
                );
            } else if (!patternCompTax.test(value)) {
                return callback(new Error("纳税人识别号只能是数字或大写字母"));
            } else {
                return callback();
            }
        };
        return {
            //发票modal
            invoiceModal: false,
            //发票信息
            formInvoice: {
                invoiceType: "1",
                titlePerson: "",
                titleBusiness: "",
                compTaxBusiness: "",
            },
            //发票校验
            formInvoiceValidate: {
                titlePerson: [
                    {
                        required: true,
                        message: "发票抬头不可为空",
                        trigger: "blur",
                    },
                ],
                titleBusiness: [
                    {
                        required: true,
                        message: "发票抬头不可为空",
                        trigger: "blur",
                    },
                ],
                compTaxBusiness: [
                    {
                        required: true,
                        validator: validateCompTax,
                        trigger: "blur",
                    },
                ],
            },
            invoiceFlag: 1,
            invoiceOrNot: false,
            invoiceMsg: false,
        };
    },
    methods: {
        handleCancel() {
            this.invoiceModal = false;
        },

        handleConfirm(name) {
            if (this.invoiceFlag === 1 && this.invoiceOrNot) {
                this.invoiceFlag = 2;
            } else if (this.invoiceFlag === 1 && !this.invoiceOrNot) {
                this.invoiceMsg = true;
            } else {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let params = {};
                        if (this.formInvoice.invoiceType === "1") {
                            this.$set(params, "invoiceType", "1");
                            this.$set(
                                params,
                                "title",
                                this.formInvoice.titlePerson
                            );
                            this.$set(params, "orderId", this.orderNum);
                            this.$set(params, "invoiceMoney", this.total);
                        }
                        if (this.formInvoice.invoiceType === "2") {
                            this.$set(params, "invoiceType", "2");
                            this.$set(
                                params,
                                "title",
                                this.formInvoice.titleBusiness
                            );
                            this.$set(
                                params,
                                "compTax",
                                this.formInvoice.compTaxBusiness.replace(
                                    /\s/g,
                                    ""
                                )
                            );
                            this.$set(params, "orderId", this.orderNum);
                            this.$set(params, "invoiceMoney", this.total);
                        }
                        postInvoiceSave(params).then((res) => {
                            if (res.statusCode === 200) {
                                if (res.data) {
                                    this.invoiceModal = false;
                                    this.invoiceFlag = 1;
                                    this.invoiceOrNot = false;
                                    this.$Message.info("发票信息提交成功");
                                } else {
                                    this.invoiceModal = false;
                                    this.invoiceFlag = 1;
                                    this.invoiceOrNot = false;
                                    this.$Message.info(
                                        "信息提交成功，发票30个工作日之内下发！"
                                    );
                                }
                            } else if (
                                res.statusCode === 270 ||
                                res.statusCode === 206 ||
                                res.statusCode === 207
                            ) {
                                this.invoiceModal = false;
                                this.invoiceFlag = 1;
                                this.invoiceOrNot = false;
                                this.$Message.info(res.data);
                            } else {
                                this.invoiceModal = false;
                                this.invoiceFlag = 1;
                                this.invoiceOrNot = false;
                                this.$Message.info(
                                    "信息提交成功，发票30个工作日之内下发！"
                                );
                            }
                        });
                    }
                });
            }
        },
    },
};
</script>

<style scoped>
.invoice-title {
    color: #4f8dfe;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
}

.invoice-msg {
    padding-left: 30px;
    color: #ed3f14;
    padding-bottom: 10px;
    font-size: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Invoice.vue